// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"670":"43473f77","745":"75e828d3","822":"9826ea58"}[chunkId] + ".js";
};